module.exports = __webpack_public_path__ + "img/m_imgBox_bg.e487f794.png";